var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"title":_vm.headerTitle}}),_c('header-progress',{attrs:{"progress":_vm.progress}}),_c('box-price',{attrs:{"property":_vm.boxPriceData}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }